// extracted by mini-css-extract-plugin
module.exports = {"section":"UniversalIntegrationsApply_section__fXyv2","wrapper":"UniversalIntegrationsApply_wrapper__uRL_y","image":"UniversalIntegrationsApply_image__RSIyu"};